import { Component, OnDestroy, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { PermissionsEnum } from 'src/app/core/enums/permissions.enum';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CompanyPreview } from 'src/app/core/interfaces/company-preview.interface';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-settings-navbar',
  templateUrl: './settings-navbar.component.html',
  styleUrls: ['./settings-navbar.component.scss']
})
export class SettingsNavbarComponent implements OnInit, OnDestroy {
  public modules = [];
  public modulePermission = PermissionsEnum;
  protected hasCompany = false;
  company$: Observable<CompanyPreview>;
  destroy$ = new Subject<any>();

  constructor(private readonly permissions: PermissionsService, private readonly companyState: Store<{ company: CompanyPreview }>) {
    this.company$ = this.companyState.pipe(select('company'));
  }

  ngOnInit(): void {
    this.modules = this.permissions.getPermissionStorage();
    this.company$.pipe(takeUntil(this.destroy$)).subscribe(async (company) => {
      this.hasCompany = !!company;
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
